import { render, staticRenderFns } from "./annualAccount.vue?vue&type=template&id=3b154e0a&"
import script from "./annualAccount.vue?vue&type=script&lang=ts&"
export * from "./annualAccount.vue?vue&type=script&lang=ts&"
import style0 from "./annualAccount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports